import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowLeft } from 'react-icons/fi';
import './pages.css';

const Terms = () => {
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    return (
        <div className="gpt3__pages gradient__bg">
            <div className="gpt3__pages-back">
                <Link to="/">
                    <FiArrowLeft /> Back to Home
                </Link>
            </div>
            <div className="gpt3__pages-content">
                <h1 className="gradient__text">Terms & Conditions</h1>
                <p>Last updated: February 28, 2026</p>
                
                <h2>1. Acceptance of Terms</h2>
                <p>By accessing and using Prinzetuner, you accept and agree to be bound by the terms and provision of this agreement.</p>
                
                <h2>2. Software Usage</h2>
                <p>Our software is provided for professional automotive tuning and file processing. You agree to use it responsibly and in compliance with all local laws and regulations regarding vehicle modifications.</p>
                
                <h2>3. Intellectual Property</h2>
                <p>All content and software on this site are the intellectual property of Prinzetuner and may not be reproduced without explicit permission.</p>
                
                <h2>4. Limitation of Liability</h2>
                <p>Prinzetuner shall not be held liable for any damages resulting from the use or misuse of our software. Vehicle modifications are performed at the user's own risk.</p>
                
                <h2>5. Modifications to Service</h2>
                <p>We reserve the right to modify or discontinue any aspect of our service at any time without prior notice.</p>
            </div>
        </div>
    );
};

export default Terms;
